export enum NotificationContentTabType {
  GENERAL = 'general',
  INSIGHTS = 'insights',
  REGISTRATION = 'registration',
  SYMPTOMS = 'symptoms',
}
